var exports = {
  "R": "x31de4314--068f10--more-button",
  "B": "x31de4314--068f10--preloader-container",
};

module.exports = exports;
